var Backbone, SupportCurrentOrderModel, SupportOrderSummaryTemplate, SupportOrderSummaryView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportUtilsHelper = require('../../helpers/utils');

SupportOrderSummaryTemplate = require('../../../order_summary.html.mustache');

SupportCurrentOrderModel = require('../../models/current_order');

Backbone = require('backbone');

Backbone.$ = $;

SupportOrderSummaryView = (function(superClass) {
  extend(SupportOrderSummaryView, superClass);

  function SupportOrderSummaryView() {
    return SupportOrderSummaryView.__super__.constructor.apply(this, arguments);
  }

  SupportOrderSummaryView.prototype.className = 'order-summary';

  SupportOrderSummaryView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportOrderSummaryTemplate;
    return this.orderPresenter = new SupportCurrentOrderModel;
  };

  SupportOrderSummaryView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.buildOrderSummaryParams(), this.I18nScope));
  };

  SupportOrderSummaryView.prototype.buildOrderSummaryParams = function() {
    return this.orderPresenter.buildOrderSummaryParams();
  };

  return SupportOrderSummaryView;

})(Backbone.View);

module.exports = SupportOrderSummaryView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9vcmRlcl9zdW1tYXJ5X3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9vcmRlcl9zdW1tYXJ5X3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsNEdBQUE7RUFBQTs7O0FBQUEsa0JBQUEsR0FBcUIsT0FBQSxDQUFRLHFCQUFSOztBQUNyQiwyQkFBQSxHQUE4QixPQUFBLENBQVEsc0NBQVI7O0FBQzlCLHdCQUFBLEdBQTJCLE9BQUEsQ0FBUSw0QkFBUjs7QUFDM0IsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBRVA7Ozs7Ozs7b0NBQ0osU0FBQSxHQUFXOztvQ0FFWCxVQUFBLEdBQVksU0FBQTtJQUNWLElBQUMsQ0FBQSxTQUFELEdBQWE7SUFDYixJQUFDLENBQUEsUUFBRCxHQUFZO1dBQ1osSUFBQyxDQUFBLGNBQUQsR0FBa0IsSUFBSTtFQUhaOztvQ0FLWixNQUFBLEdBQVEsU0FBQTtXQUNOLElBQUMsQ0FBQSxHQUFHLENBQUMsTUFBTCxDQUFZLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixJQUFDLENBQUEsdUJBQUQsQ0FBQSxDQUFsQixFQUE4QyxJQUFDLENBQUEsU0FBL0MsQ0FBWjtFQURNOztvQ0FHUix1QkFBQSxHQUF5QixTQUFBO1dBQ3ZCLElBQUMsQ0FBQSxjQUFjLENBQUMsdUJBQWhCLENBQUE7RUFEdUI7Ozs7R0FYVyxRQUFRLENBQUM7O0FBYy9DLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
